import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from 'tbk-components/src/components/BasicElement';
import { IStep } from '.';
import Button from 'tbk-components/src/components/Button';

interface IStepI18nProps {
	step?: string;
}

export interface IStepDetailsProps extends IBaseElementProps {
	steps: IStep[];
	current?: number;
	i18n?: IStepI18nProps;
}

const StepDetails: React.FC<IStepDetailsProps> = ({
	steps = [],
	current,
	i18n,
	className,
	classNames = [],
}) => {
	const currentStep = steps[current];
	const currentStepIndex = current || 0;

	return (
		<div className={className || cn('step-details', ...classNames)}>
			<div className="step-details__container">
				<div className="step-details__left-block">
					{currentStep && (
						<div className="step-details__number">
							{i18n?.step || 'Step'} {currentStepIndex + 1}
						</div>
					)}
					{currentStep?.instructions && (
						<h2 className="step-details__instructions">
							{currentStep?.instructions}
						</h2>
					)}

					{currentStep?.skippable && (
						<Button
							className="step-details__skip text-decoration-none d-inline-flex align-items-center"
							{...currentStep?.skippable}
							label="Skip this step"
						>
							<span className="icon icon-caret-right-slim"></span>
						</Button>
					)}
				</div>
				{currentStep?.detailedInstructions && (
					<p className="step-details__detailed-instructions">
						{currentStep?.detailedInstructions}
					</p>
				)}
			</div>
		</div>
	);
};

export default StepDetails;
